var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_c('div',{staticClass:"font-weight-bold text-monospace"},[_vm._v(" "+_vm._s(_vm.operator)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }